export const PATHS = {
  AUTH: {
    LOGIN: "/login",
  },
  HOME: "/home",
  PROPOSAL: "/proposal",
  ORDERS: "/orders",
  ORDER_DETAIL: "/orders/:orderId",
  ORDER_CREATE: "/orders/create",
  ORDER_CONFIRM: "/orders/confirm",
  PROPOSAL_DETAIL: "/proposal/:proposalId",
  PROFILE: "/profile",
} as const;

